module.exports = __webpack_public_path__ + "static/media/focus-devices.af912938.jpg";